<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { decisionSeverity } from '@/pages/banks/my-bank/utils'

const props = defineProps<{
  decision?: App.Enums.PartnerBankDecision | null
}>()

const { t } = useI18n()

const severity = computed(() => decisionSeverity(props.decision))
const label = computed(() => (props.decision ? t(`decision.${props.decision}`) : t('decision.unknown')))
</script>

<template>
  <Tag :value="label" :severity="severity" class="w-fit" />
</template>

<i18n>
{
  "de": {
    "decision": {
      "yes": "Ja",
      "no": "Nein",
      "case_by_case": "Einzelfall",
      "unknown": "Keine Angabe"
    }
  },
  "en": {
    "decision": {
      "yes": "Yes",
      "no": "No",
      "case_by_case": "Case by case",
      "unknown": "Not specified"
    }
  }
}
</i18n>
